module.exports = __webpack_public_path__ + "static/media/advanced_image.0c039778.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/MobileApp/assets/advanced_image.png
// module id = 548
// module chunks = 0